/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import clsx from 'clsx';
import moment from 'moment';

import { useLazyQuery, useApolloClient } from '@apollo/client';

import { PropertyCard } from '@marriott/mi-shop-components/src/molecules';
import {
  APPLICATION_BREAKPOINTS,
  getESTDate,
  useWindowSize,
  Pagination,
  AlertNotification,
} from '@marriott/mi-ui-library';
import { SkeletonOutletCardLoader } from 'libs/mi-awp-components/src/organisms/SearchResults/SkeletonOutletCardLoader';
import {
  phoenixLeisureDestinationPropertiesByGeolocation,
  phoenixLeisureDestinationPropertiesByLocation,
  phoenixLeisureExchangeRateByCurrencyCodes,
  phoenixLeisureSearchLowestAvailableRatesByGeolocation,
  phoenixLeisureSearchLowestAvailableRatesByLocation,
} from '@marriott/mi-leisure-graphql';
import { UXL_ERROR_POLICY } from 'libs/mi-offers-components/src/api/apiConstants';
import { EXTERNAL_CTA_TYPE, HOTEL_VIEW } from 'libs/mi-offers-components/src/constants/CommonConstants';
import { usePersistentGlobalStore } from '@marriott/mi-store-utils';

import { eventUtil } from 'libs/mi-ui-library/src/utils/eventUtil';

import { useGetBreakpoint } from '../../../../src/utils/CommonUtils';
import { constructJsonSchema } from '../../../../src/utils/generateJsonSchemaUtils';
import {
  MARRIOTT_CACHE_URL,
  outputInterpolation,
  outputQuality,
  PARAM_PAGENO,
  HOTEL_MARKETING_CAPTION,
  INCLUDES_LABEL,
  VIEW_RATE_LABEL,
} from '../../../constants/CommonConstants';
import { processAcceptLang } from '../../../utils/CommonUtils';

import {
  getCalculatedDistance,
  getReviewDetailsClientSide,
  getSearchResultQuery,
  priceDimensionMapping,
  getMandatoryFeeDescription,
  getTitleClientSide,
  handleSortByEvent,
  getFooterDetails,
  getCountryCode,
  isCityDestination,
} from '../utils/helper';
import { constructMandatoryFeeTitle, constructToolTipTitle, identifyTypeOfMandatoryFee } from '../utils/ratesHelper';

import PropertiesListGridViewSkeletonLoader from '../PropertiesListGridViewSkeletonLoader/PropertiesListGridViewSkeletonLoader';
import { BrandProps, ControlsProps, availableBrandsType } from '../PropertiesListFilter/PropertiesListFilter.types';
import { imgDimensionType, propertyCardDataType, searchDataType } from '../OfferPropertiesList.types';
import { PropertiesListFilter } from '../PropertiesListFilter';
import { SortByFilterComponent } from './sortByFilter';
import { StyledPropertiesListWrapper } from './PropertiesListWrapper.styles';
import { AriesOfferType } from './PropertiesListWrapper.types';

// WEB-70169 - using this to excude the mock file from production build
const propertiesListUXLMockJson = async (isAuthorMode: boolean, isStateCountryOrSearch: boolean) => {
  if (process.env['NODE_ENV'] === 'development' || isAuthorMode) {
    const propertiesListUXLMockJson: unknown = await (isStateCountryOrSearch
      ? import('../__mock__/phoenixLeisureDestinationPropertiesByLocation.mock.json')
      : import('../__mock__/phoenixLeisureDestinationPropertiesByGeolocation.mock.json')); //Load mock model dynamically only for dev mode
    return propertiesListUXLMockJson;
  }
  return {};
};

export const PropertiesListWrapper: React.FC<any> = props => {
  const isMobileViewPort = useGetBreakpoint() === 'mobile';
  const { width } = useWindowSize();
  const { isAuthorMode, model, sessionData, currentLocale } = props;
  const currentLocaleVal = currentLocale ?? 'en-US';
  const apolloClientRef = useApolloClient(); // create apollo client instance
  const updateGlobalData = usePersistentGlobalStore((state: any) => state.updateGlobalData);
  const setGlobalData = usePersistentGlobalStore((state: any) => state.setGlobalData);

  const globalData = usePersistentGlobalStore((state: any) => state.globalData);
  const ariesOffer: AriesOfferType = globalData?.sessionData?.cacheData?.data?.AriesOffer
    ? globalData?.sessionData?.cacheData?.data?.AriesOffer
    : globalData?.AriesOffer ?? {};
  const [sessionDataUpdate, setSessionDataUpdate] = useState(globalData?.sessionData);
  const currentDestination =
    typeof window !== 'undefined' ? window?.location?.pathname?.split('?')[0].replace(/\.mi$/, '') : '';
  const destinationMetaData = props?.destinationMetaData ?? {};
  const countryCode = getCountryCode(destinationMetaData) ?? '';

  const { isGridview, cardsPerPage } = model?.staticData ?? {};
  const acceptLanguage = processAcceptLang(props?.acceptLanguage ?? '');
  const requestId = props?.requestId;
  const startDate = moment(new Date()).format('YYYY-MM-DD');
  const endDate = moment(startDate).add(1, 'days').format('YYYY-MM-DD');
  const subdirectory = props?.subDirectoryVal ?? '';
  const clusterCode = props?.offersData?.responseObject?.edges[0].node.clusterCode;
  const { isStateEnabled } = destinationMetaData ?? {};
  const hasInitialised = useRef<boolean>(false);
  const isFirstRender = useRef(true);
  const [cliensideData, setCliensideData] = useState(false);
  const hasDefaultFilters =
    destinationMetaData?.amenities?.length ||
    destinationMetaData?.activities?.length ||
    destinationMetaData?.hotelType?.length;
  useEffect(() => {
    // Once the component has rendered, set the flag to false
    isFirstRender.current = false;
  }, []); // Empty dependency array, so this effect only runs once
  // clear filters from session when different offer is loaded in same browser window

  const Enable_DTT_queries = props?.isDTT ?? false;
  const propertiesQuery = !isCityDestination(destinationMetaData)
    ? Enable_DTT_queries
      ? phoenixLeisureSearchLowestAvailableRatesByLocation
      : phoenixLeisureDestinationPropertiesByLocation
    : Enable_DTT_queries
    ? phoenixLeisureSearchLowestAvailableRatesByGeolocation
    : phoenixLeisureDestinationPropertiesByGeolocation;
  const [dataLoaderFlag, setDataLoaderFlag] = useState<boolean>(false);
  const [updateCards, setUpdateCards] = useState<boolean>(false);
  const [pageCardCountInfo, setPageCardCountInfo] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [sortOptions, setSortOptions] = useState<{ sortByOptionTitle: string; sortByOptionCode: string }[]>([]);

  const [sortBy, setSortBy] = useState(model?.sortByData?.sortBy);
  //pagination
  let page = 1;
  let offset = 0;
  if (typeof window !== 'undefined') {
    const url = new URL(window?.location?.href, window?.location?.href); // Use the full URL
    const pageNo = url.searchParams.get(PARAM_PAGENO);
    page = parseInt(pageNo ? pageNo : '1');
    offset = (page - 1) * cardsPerPage;
  }
  const [currentPage, setCurrentPage] = useState<number>(page);
  const [offsetValue, setOffsetValue] = useState<number>(offset);

  const isStateOrCountryEnabled = !isCityDestination(destinationMetaData);

  const getImageSetup = (): imgDimensionType => {
    let imageDimensions = {
      height: 288,
      width: 512,
    };
    if (Number(width) < APPLICATION_BREAKPOINTS['viewportL']) {
      imageDimensions = {
        height: 240,
        width: 360,
      };
    }
    if (Number(width) > APPLICATION_BREAKPOINTS['viewportL'] || Number(width) < APPLICATION_BREAKPOINTS['viewportS']) {
      imageDimensions = {
        height: 222,
        width: 715,
      };
    }
    return imageDimensions;
  };
  const getImageProps = (): string => {
    const imageDimensions = getImageSetup();
    const imgProp =
      `?output-quality=${outputQuality}&interpolation=${outputInterpolation};*,*&downsize=` +
      imageDimensions.width +
      'px:*';
    return imgProp;
  };
  const imageProperties = getImageProps();
  //scroll to top of the list on pagination.
  const handleScrollOnPagination = (): void => {
    const targetSection = document.getElementById('filter-btns-wrapper')?.offsetTop;
    window.scrollTo({
      top: targetSection ? (model.seoFriendlyPagination ? targetSection - 285 : targetSection - 100) : 0,
      behavior: 'smooth',
    });
  };
  const onPageItemClick = (pageNumber: number): void => {
    if (!model.seoFriendlyPagination) {
      setDataLoaderFlag(true);
      const offset = (pageNumber - 1) * cardsPerPage;
      setCurrentPage(pageNumber);
      setOffsetValue(offset);
      handleScrollOnPagination();
    }
  };

  //Handles scroll to this component functionality in pagination
  useEffect(() => {
    if (!model.seoFriendlyPagination || typeof window === 'undefined') return;

    const urlParams = new URLSearchParams(window.location.search);
    const hasPgParam = urlParams.has(PARAM_PAGENO);
    const destinationsPagination = window.sessionStorage.getItem('destinationsSeoFriendlyPagination') === 'true';

    if (hasPgParam || destinationsPagination) {
      window.sessionStorage.setItem('destinationsSeoFriendlyPagination', 'true');
      handleScrollOnPagination();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [searchData, setSearchData] = useState<searchDataType>({
    startDate: startDate,
    endDate: endDate,
    childAges: [],
    numberInParty: 1,
    quantity: 1,
  });
  const [propertyCardData, setPropertyCardData] = useState<propertyCardDataType>({
    hotels: [],
    totalProperties: 0,
  });

  const [isNewFacetsLoading, setIsNewFacetsLoading] = useState<boolean>(false);
  let keepDefaultFilters = false;
  if (
    destinationMetaData?.amenities?.length ||
    destinationMetaData?.activities?.length ||
    destinationMetaData?.hotelType?.length
  ) {
    keepDefaultFilters = true;
  }
  //For dynamic filters
  const setDynamicFilterState = (
    keepDefaultFilters: boolean,
    destinationData: string[] | undefined,
    sessionData: string[] | undefined
  ): string[] => {
    return keepDefaultFilters && destinationData?.length ? destinationData : sessionData?.length ? sessionData : [];
  };
  // brand filter state variables
  const [availableBrands, setAvailableBrands] = useState<availableBrandsType[]>([]); // brands which are cominng as facets from uxl & available for selection
  const [selectedBrands, setSelectedBrands] = useState<BrandProps[]>(
    model?.hasdestinationChanged ? model?.sessionFromServer?.selectedBrands : ariesOffer?.selectedBrands ?? []
  );
  // brands which are selected for filtering of list
  const sessionBrandFacetList =
    ariesOffer && ariesOffer?.['selectedBrands'] ? ariesOffer?.['selectedBrands']?.map((item: any) => item.code) : [];
  const [brandFacets, setBrandFacets] = useState<string[]>(sessionBrandFacetList?.length ? sessionBrandFacetList : []);
  const [dynamicBrand, setDynamicBrand] = useState<string[]>([]); //
  //amenties filter
  const [availabledAmenities, setAvailableAmenities] = useState<ControlsProps[]>([]);
  const selectedAmenitiesData = model?.hasdestinationChanged
    ? model?.sessionFromServer?.selectedAmenities
    : ariesOffer?.selectedAmenities ?? [];
  const [selectedAmenities, setSelectedAmenities] = useState<string[]>(selectedAmenitiesData ?? []);
  const sessionAmenitiesFacetList =
    ariesOffer && ariesOffer?.selectedAmenities ? ariesOffer?.selectedAmenities?.map(item => item.code) : [];
  const [amentiesFacets, setAmenitiesFacets] = useState<string[]>(
    keepDefaultFilters && destinationMetaData?.amenities?.length
      ? destinationMetaData?.amenities
      : sessionAmenitiesFacetList?.length
      ? sessionAmenitiesFacetList
      : []
  );
  //For Aminities
  const [dynamicAmenities, setDynamicAmenities] = useState<string[]>(
    setDynamicFilterState(keepDefaultFilters, destinationMetaData?.amenities, sessionAmenitiesFacetList)
  );
  //transportation filter
  const [availableTransportaion, setAvailableTransportaion] = useState<ControlsProps[]>([]);
  const [selectedTransportaion, setSelectedTransportaion] = useState<AriesOfferType['selectedTransportaion']>(
    ariesOffer?.selectedTransportaion ?? []
  );
  const sessionTransportaionFacetList =
    ariesOffer && ariesOffer?.['selectedTransportaion']
      ? ariesOffer?.['selectedTransportaion'].map((item: any) => item?.code)
      : [];
  const [transportaionFacets, setTransportaionFacets] = useState<string[]>(
    sessionTransportaionFacetList?.length ? sessionTransportaionFacetList : []
  );
  const [dynamicTransportation, setDynamicTransportation] = useState<string[]>([]);
  //hotel type filter
  const [availableHotelType, setAvailableHotelType] = useState<ControlsProps[]>([]);
  const [selectedHotelType, setSelectedHotelType] = useState<string[]>(
    model?.hasdestinationChanged ? model?.sessionFromServer?.selectedHotelType : ariesOffer.selectedHotelType ?? []
  );
  const sessionHotelTypeFacetList =
    ariesOffer && ariesOffer?.['selectedHotelType']
      ? ariesOffer?.['selectedHotelType'].map((item: any) => item?.code)
      : [];
  const [hotelTypeFacets, setHotelTypeFacets] = useState<string[]>(
    keepDefaultFilters && destinationMetaData?.hotelType?.length
      ? destinationMetaData?.hotelType
      : sessionHotelTypeFacetList?.length
      ? sessionHotelTypeFacetList
      : []
  );
  //For hotelType
  const [dynamicHotelType, setDynamicHotelType] = useState<string[]>(
    setDynamicFilterState(keepDefaultFilters, destinationMetaData?.hotelType, sessionHotelTypeFacetList)
  );
  //events filter
  const [availablEvents, setAvailableEvents] = useState<ControlsProps[]>([]);
  const [selectedEvents, setSelectedEvents] = useState<AriesOfferType['selectedEvents']>(
    ariesOffer?.selectedEvents ?? []
  );
  const sessionEventsFaceList =
    ariesOffer && ariesOffer?.['selectedEvents'] ? ariesOffer?.['selectedEvents']?.map((item: any) => item?.code) : [];
  const [eventsFacets, setEventsFacets] = useState<string[]>(
    sessionEventsFaceList?.length ? sessionEventsFaceList : []
  );
  const [dynamicEvents, setDynamicEvents] = useState<string[]>([]);
  //activities filter
  const [availablActivities, setAvailableActivities] = useState<ControlsProps[]>([]);
  const [selectedActivities, setSelectedActivities] = useState<AriesOfferType['selectedActivities']>(
    model?.hasdestinationChanged ? model?.sessionFromServer?.selectedActivities : ariesOffer?.selectedActivities ?? []
  );
  const sessionActivitiesFacetList =
    ariesOffer && ariesOffer?.['selectedActivities']
      ? ariesOffer?.['selectedActivities']?.map((item: any) => item?.code)
      : [];
  const [activitiesFacets, setActivitiesFacets] = useState<string[]>(
    keepDefaultFilters && destinationMetaData?.activities?.length
      ? destinationMetaData?.activities
      : sessionActivitiesFacetList?.length
      ? sessionActivitiesFacetList
      : []
  );
  //For Activities
  const [dynamicActivities, setDynamicActivities] = useState<string[]>(
    setDynamicFilterState(keepDefaultFilters, destinationMetaData?.activities, sessionActivitiesFacetList)
  );
  //price filter
  const [availablPrices, setAvailablPrices] = useState<ControlsProps[]>([]);
  
  const taxFlag = acceptLanguage === 'en-US' && countryCode !== 'GB' && countryCode !== 'JP' ? false : true;
  const [showPricesTax, setShowPricesTax] = useState<boolean>(
    model?.isServerSideData ? model?.processedData?.showPricesTax : ariesOffer?.['showPricesTax'] ?? taxFlag
  );
  const [dynamicShowPricesTax, setDynamicShowPricesTax] = useState<boolean>(
    model?.isServerSideData ? model?.processedData?.showPricesTax : ariesOffer?.['showPricesTax'] ?? taxFlag
  );

  const mandatoryFeesEnabled =
    acceptLanguage === 'en-US' || props?.dataLayer?.data?.[0]?.browser_akamai_loc_country === 'UK' ? true : false;
  const [selectedPrices, setSelectedPrices] = useState<ControlsProps[]>(
    model?.hasdestinationChanged
      ? model?.sessionFromServer?.selectedPrices
      : ariesOffer?.['selectedPrices']?.length
      ? ariesOffer?.['selectedPrices']
      : [
          {
            label: 'Any Price',
            disabled: false,
          },
        ]
  );
  const defaultCurrency = model?.processedData?.defaultCurrency ?? '';
  const [selectedCurrency, setSelectedCurrency] = useState<ControlsProps[]>(
    model?.isServerSideData && !cliensideData && model?.processedData?.selectedCurrency
      ? model?.processedData?.selectedCurrency
      : ariesOffer?.['selectedCurrency'] ?? null
  );
  const [currencyConversionRate, setCurrencyConversionRate] = useState<{ [key: string]: number }>(
    model?.isServerSideData && !cliensideData && model?.processedData?.currencyConversionRate
      ? model?.processedData?.currencyConversionRate
      : {}
  );
  const priceRange =
    ariesOffer && ariesOffer?.['selectedPrices'] ? ariesOffer?.['selectedPrices']?.[0]?.label : 'Any Price';
  const key = priceRange as keyof typeof priceDimensionMapping;
  const priceDimensionVal = priceDimensionMapping[key];

  const [priceDimension, setPriceDimension] = useState<any[]>(priceDimensionVal);
  const [dynamicPrice, setDynamicPrice] = useState<string[]>([]);
  // city
  const [availableCity, setAvailableCity] = useState<ControlsProps[]>([]);
  const [selectedCity, setSelectedCity] = useState<AriesOfferType['selectedCity']>(ariesOffer?.selectedCity ?? []);
  const sessionCitiesFacetList =
    ariesOffer && ariesOffer?.['selectedCity'] ? ariesOffer?.['selectedCity']?.map((item: any) => item?.code) : [];
  const [cityFacets, setCityFacets] = useState<string[]>(sessionCitiesFacetList?.length ? sessionCitiesFacetList : []);
  const [dynamicCity, setDynamicCity] = useState<string[]>([]);
  //state
  const [availablState, setAvailableState] = useState<ControlsProps[]>([]);
  const [selectedState, setSelectedState] = useState<AriesOfferType['selectedState']>(ariesOffer?.selectedState ?? []);
  const sessionStatesFacetList =
    ariesOffer && ariesOffer?.['selectedState'] ? ariesOffer?.['selectedState']?.map((item: any) => item?.code) : [];
  const [stateFacets, setStateFacets] = useState<string[]>(
    sessionStatesFacetList?.length ? sessionStatesFacetList : []
  );
  const [dynamicState, setDynamicState] = useState<string[]>([]);
  //availability
  const [includeUnavailableProperties, setIncludeUnavailableProperties] = useState<boolean>(
    ariesOffer?.includeUnavailableProperties ?? true
  );
  const [dynamicIncludeUnavailableProperties, setDynamicIncludeUnavailableProperties] = useState<boolean>(true);
  const alertsListArray = props?.model?.alertsListArray ?? [];
  const alertMsgType = alertsListArray?.[0]?.alertMsgType ?? '';
  const alertCodeListModel = alertsListArray?.[0]?.alertCodeListModel?.[0] ?? [];

  const paginationPanelLabel = {
    previous: model?.previous,
    next: model?.next,
  };

  const trackingProperties = model?.trackingProperties;

  useEffect(() => {
    let payLoad = {};
    if (hasInitialised.current) {
      const inputVariable = getSearchResultQuery(
        searchData,
        destinationMetaData ?? {},
        offsetValue,
        updateCards ? brandFacets : dynamicBrand,
        cardsPerPage,
        sortBy,
        updateCards ? amentiesFacets : dynamicAmenities,
        updateCards ? transportaionFacets : dynamicTransportation,
        updateCards ? hotelTypeFacets : dynamicHotelType,
        updateCards ? eventsFacets : dynamicEvents,
        updateCards ? activitiesFacets : dynamicActivities,
        updateCards ? priceDimension : dynamicPrice,
        updateCards ? cityFacets : dynamicCity,
        updateCards ? stateFacets : dynamicState,
        updateCards ? includeUnavailableProperties : dynamicIncludeUnavailableProperties,
        updateCards ? showPricesTax : dynamicShowPricesTax,
        currentLocaleVal,
        mandatoryFeesEnabled
      );
      payLoad = {
        variables: {
          ...inputVariable,
        },
      };
    }
    if (isAuthorMode) {
      (async () => {
        const getPropertiesListUXLMockJson = await propertiesListUXLMockJson(isAuthorMode, isStateOrCountryEnabled);
        const modifiedPropertyCardData = modifyPropertyCardData(getPropertiesListUXLMockJson);
        updateCards &&
          setPropertyCardData({
            hotels: modifiedPropertyCardData?.hotels,
            totalProperties: modifiedPropertyCardData.totalProperties,
          });

        setDataLoaderFlag(false);
        setPageCardCountInfo(getPageCardCountInfo(modifiedPropertyCardData?.totalProperties));
        modifiedPropertyCardData?.totalProperties === 0
          ? setErrorMessage(model?.offerParticipatingPropertiesError)
          : setErrorMessage('');
      })();
    } else {
      if (!hasInitialised.current) {
        hasInitialised.current = true;
      } else {
        setIsNewFacetsLoading(true);
        getPropertiesListdata(payLoad)
          .then(result => {
            processPropertiesList(result?.data);
          })
          .catch(err => {
            setIsNewFacetsLoading(false);
            console.log('error ', err);
          });
      }
    }
    if (hasInitialised.current) {
      setOffsetValue(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    searchData,
    currentPage,
    brandFacets,
    sortBy,
    amentiesFacets,
    transportaionFacets,
    hotelTypeFacets,
    eventsFacets,
    activitiesFacets,
    priceDimension,
    cityFacets,
    stateFacets,
    includeUnavailableProperties,
    dynamicBrand,
    dynamicAmenities,
    dynamicTransportation,
    dynamicHotelType,
    dynamicEvents,
    dynamicActivities,
    dynamicPrice,
    dynamicCity,
    dynamicState,
    dynamicIncludeUnavailableProperties,
  ]);

  //on click of apply filter button
  const handleApplyFilter = (
    selectedBrandsList: any,
    selectedAmenitiesList: any,
    selectedTransportationList: any,
    selectedHotelTypeList: any,
    selectedEventsList: any,
    selectedActivitiesList: any,
    selectedPricesList: any,
    selectedCurrencyList: any,
    selectedCitiesList: any,
    selectedStatesList: any,
    includeUnavailableProperties: boolean,
    isTaxSliderActive: boolean,
    sortByVal?: any
  ) => {
    const sortVal = sortByVal ?? sortBy;
    setDataLoaderFlag(true);
    setCliensideData(true);
    setUpdateCards(true);
    //add applied filters to session
    addFilterStateToSession(
      selectedBrandsList,
      selectedAmenitiesList,
      selectedTransportationList,
      selectedHotelTypeList,
      selectedEventsList,
      selectedActivitiesList,
      selectedPricesList,
      selectedCurrencyList,
      currencyConversionRate,
      selectedCitiesList,
      selectedStatesList,
      includeUnavailableProperties,
      isTaxSliderActive,
      sortVal
    );
    //brands
    setSelectedBrands(selectedBrandsList);
    const brandFacetList = selectedBrandsList?.map((item: any) => item.code);
    setBrandFacets(brandFacetList);
    //amentities
    setSelectedAmenities(selectedAmenitiesList);
    const amenitiesFacetList = selectedAmenitiesList?.map((item: any) => item?.code);
    setAmenitiesFacets(amenitiesFacetList);
    //transportation
    setSelectedTransportaion(selectedTransportationList);
    const transportaionFacetList = selectedTransportationList?.map((item: any) => item?.code);
    setTransportaionFacets(transportaionFacetList);
    //hotel type
    setSelectedHotelType(selectedHotelTypeList);
    const hotelTypeFacetList = selectedHotelTypeList?.map((item: any) => item?.code);
    setHotelTypeFacets(hotelTypeFacetList);
    //events
    setSelectedEvents(selectedEventsList);
    const eventsFaceList = selectedEventsList?.map((item: any) => item?.code);
    setEventsFacets(eventsFaceList);
    //activities
    setSelectedActivities(selectedActivitiesList);
    const activitiesFacetList = selectedActivitiesList?.map((item: any) => item?.code);
    setActivitiesFacets(activitiesFacetList);
    //prices
    setSelectedPrices(selectedPricesList);
    const priceRange = selectedPricesList?.[0]?.label;
    const key = priceRange as keyof typeof priceDimensionMapping;
    const priceDimensionVal = priceDimensionMapping[key];
    setPriceDimension(priceDimensionVal);
    //city
    setSelectedCity(selectedCitiesList);
    const citiesFacetList = selectedCitiesList?.map((item: any) => item?.code);
    setCityFacets(citiesFacetList);
    //state
    setSelectedState(selectedStatesList);
    const statesFacetList = selectedStatesList?.map((item: any) => item?.code);
    setStateFacets(statesFacetList);
    //availablity
    setIncludeUnavailableProperties(includeUnavailableProperties);
    setShowPricesTax(isTaxSliderActive);
    setSortBy(sortVal);
    setCurrentPage(1);
  };
  //on only currency update
  const handleApplyCurrencyFilter = async (selCurrency: any) => {
    //currency
    const currencyConversionRateVal = await handleCurrencyChange(selCurrency);
    //add applied currency filter to session
    addFilterStateToSession(
      selectedBrands,
      selectedAmenities,
      selectedTransportaion,
      selectedHotelType,
      selectedEvents,
      selectedActivities,
      selectedPrices,
      selCurrency,
      currencyConversionRateVal,
      selectedCity,
      selectedState,
      includeUnavailableProperties,
      showPricesTax,
      sortBy
    );
    // setSelectedCurrency(selCurrency);
    setCurrencyConversionRate(currencyConversionRate);
  };
  const handleClearAllFilters = (filterCategory: string) => {
    // setDataLoaderFlag(true);
    setIsNewFacetsLoading(true);
    setUpdateCards(false);
    // setCliensideData(true); //?
    keepDefaultFilters = false;
    if (filterCategory === 'All Filters') {
      //clear brands
      setSelectedBrands([]);
      //clear Amenities
      setSelectedAmenities([]);
      //clear Transportaion
      setSelectedTransportaion([]);
      //clear hotel type
      setSelectedHotelType([]);
      //clear events
      setSelectedEvents([]);
      //clear price filters
      setSelectedPrices([
        model?.anyPriceLabel
          ? { label: `${model?.anyPriceLabel}`, disabled: false }
          : { label: 'Any Price', disabled: false },
      ]);
      setPriceDimension(priceDimensionVal);
      // set currency to default
      setSelectedCurrency([
        {
          label: model?.defaultLabel ?? 'Default',
          code: '',
          disabled: false,
        },
      ]);
      setCurrencyConversionRate({});
      //clear activities
      setSelectedActivities([]);
      //clear city
      setSelectedCity([]);
      //clear state
      setSelectedState([]);
    } else if (filterCategory === 'Brands') {
      setSelectedBrands([]);
    } else if (filterCategory === 'Amenities') {
      setSelectedAmenities([]);
    } else if (filterCategory === 'Price') {
      selectedPrices?.[0]?.label === model?.anyPriceLabel &&
        selectedCurrency?.[0]?.label !== model?.defaultLabel &&
        setIsNewFacetsLoading(false);
      setSelectedPrices([
        model?.anyPriceLabel
          ? { label: `${model?.anyPriceLabel}`, disabled: false }
          : { label: 'Any Price', disabled: false },
      ]);
      setPriceDimension(priceDimensionVal);
      // set currency to default
      setSelectedCurrency([
        {
          label: model?.defaultLabel ?? 'Default',
          code: '',
          disabled: false,
        },
      ]);
      setCurrencyConversionRate({});
    }
    setCurrentPage(1);
  };
  const handleDynamicBrands = (brands: any) => {
    setIsNewFacetsLoading(true);
    setUpdateCards(false);
    setSelectedBrands(brands);
    const brandFacetList = brands?.map((item: any) => item?.code);
    setDynamicBrand(brandFacetList);
  };
  const handleDynamicAmenities = (amenities: any) => {
    setIsNewFacetsLoading(true);
    setUpdateCards(false);
    setSelectedAmenities(amenities);
    const amenitiesFacetList = amenities?.map((item: any) => item?.code);
    setDynamicAmenities(amenitiesFacetList);
  };
  const handleDynamicTransportaion = (transportaions: any) => {
    setIsNewFacetsLoading(true);
    setUpdateCards(false);
    setSelectedTransportaion(transportaions);
    const transportaionFacetList = transportaions?.map((item: any) => item?.code);
    setDynamicTransportation(transportaionFacetList);
  };
  const handleDynamicHotelTypes = (hotelTypes: any) => {
    setIsNewFacetsLoading(true);
    setUpdateCards(false);
    setSelectedHotelType(hotelTypes);
    const hotelTypeFacetList = hotelTypes?.map((item: any) => item?.code);
    setDynamicHotelType(hotelTypeFacetList);
  };
  const handleDynamicActivities = (activities: any) => {
    setIsNewFacetsLoading(true);
    setUpdateCards(false);
    setSelectedActivities(activities);
    const activitiesFacetList = activities?.map((item: any) => item?.code);
    setDynamicActivities(activitiesFacetList);
  };
  const handleDynamicEvents = (brands: any) => {
    setIsNewFacetsLoading(true);
    setUpdateCards(false);
    setSelectedEvents(brands);
    const brandFacetList = brands?.map((item: any) => item?.code);
    setDynamicEvents(brandFacetList);
  };
  const handleDynamicPrices = (prices: any) => {
    setIsNewFacetsLoading(true);
    setUpdateCards(false);
    setSelectedPrices(prices);
    const priceRange = prices?.[0]?.label;
    const key = priceRange as keyof typeof priceDimensionMapping;
    const priceDimensionVal = priceDimensionMapping[key];
    setDynamicPrice(priceDimensionVal);
  };
  const handleDynamicCurrency = (selCurrency: any) => {
    setSelectedCurrency(selCurrency);
  };
  const handleDynamicPricesAndTax = (priceTax: boolean) => {
    setIsNewFacetsLoading(false);
    setUpdateCards(false);
    // setShowPricesTax(priceTax);
    setDynamicShowPricesTax(priceTax);
  };
  const handleDynamicCities = (cities: any) => {
    setIsNewFacetsLoading(true);
    setUpdateCards(false);
    setSelectedCity(cities);
    const cityFacetList = cities?.map((item: any) => item?.code);
    setDynamicCity(cityFacetList);
  };
  const handleDynamicStates = (states: any) => {
    setIsNewFacetsLoading(true);
    setUpdateCards(false);
    setSelectedState(states);
    const stateFacetList = states?.map((item: any) => item?.code);
    setDynamicState(stateFacetList);
  };
  const handleDynamicIncludeUnavailableProperties = (flag: any) => {
    setIsNewFacetsLoading(true);
    setUpdateCards(false);
    setIncludeUnavailableProperties(flag);
    setDynamicIncludeUnavailableProperties(flag);
  };
  //update session with selected filters
  const updateSessionObj = async (ariesOffer: any = {}) => {
    const sessionToken = sessionData?.sessionToken;
    try {
      const url = '/mi/phoenix-gateway/v1/updateSession';
      const headers = {
        Cookie: `sessionID=${sessionToken}`,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      };
      const payload = {
        AriesOffer: { ...ariesOffer, AriesSessionDestination: currentDestination },
        remove: [],
      };
      await axios
        .post(url, payload, {
          headers: headers,
        })
        .then((res: any) => {
          return res?.status;
        });
    } catch (error) {
      console.log(`[DESTINATION] filters update session API Failed:, ${error}`); // eslint-disable-line no-console
    }
  };
  const addFilterStateToSession = (
    selectedBrandsList: any,
    selectedAmenitiesList: any,
    selectedTransportaionList: any,
    selectedHotelTypeList: any,
    selectedEventsList: any,
    selectedActivitiesList: any,
    selectedPricesList: any,
    selectedCurrencyList: any,
    currencyConversionRate: any,
    selectedCityList: any,
    selectedStateList: any,
    includeUnavailableProperties: boolean,
    isTaxSliderActive: boolean,
    sortVal?: string
  ) => {
    let ariesOffer: any = globalData?.sessionData?.cacheData?.data?.AriesOffer;
    ariesOffer = {
      ...ariesOffer,
      selectedBrands: selectedBrandsList,
      selectedAmenities: selectedAmenitiesList,
      selectedTransportaion: selectedTransportaionList,
      selectedHotelType: selectedHotelTypeList,
      selectedEvents: selectedEventsList,
      selectedActivities: selectedActivitiesList,
      selectedPrices: selectedPricesList,
      selectedCurrency: selectedCurrencyList,
      currencyConversionRate: currencyConversionRate,
      selectedCity: selectedCityList,
      selectedState: selectedStateList,
      includeUnavailableProperties: includeUnavailableProperties,
      showPricesTax: isTaxSliderActive,
      sortBy: sortVal ? sortVal : sortBy,
    };
    let updatedSessionData: any = sessionData;

    if (sessionData?.data) {
      updatedSessionData = {
        ...updatedSessionData,
        data: {
          ...updatedSessionData?.cacheData?.data,
          AriesOffer: ariesOffer,
        },
      };
    } else {
      updatedSessionData = {
        ...updatedSessionData,
        cacheData: {
          ...updatedSessionData?.cacheData,
          data: {
            ...updatedSessionData?.cacheData?.data,
            AriesOffer: ariesOffer,
          },
        },
      };
    }
    setGlobalData({
      ...globalData,
      sessionData: updatedSessionData,
    });
    setSessionDataUpdate(updatedSessionData);
    updateGlobalData('sessionData', updatedSessionData);
    updateSessionObj(ariesOffer);
  };
  // RESET FILTERS
  useEffect(() => {
    if (model?.hasdestinationChanged) {
      addFilterStateToSession(
        [],
        hasDefaultFilters && destinationMetaData?.amenities?.length > 0
          ? [
              {
                code: destinationMetaData?.amenities?.[0],
              },
            ]
          : [],
        [],
        hasDefaultFilters && destinationMetaData?.hotelType?.length > 0
          ? [
              {
                code: destinationMetaData?.hotelType?.[0],
              },
            ]
          : [],
        [],
        hasDefaultFilters && destinationMetaData?.activities?.length > 0
          ? [
              {
                code: destinationMetaData?.activities?.[0],
              },
            ]
          : [],
        [
          {
            label: model?.anyPriceLabel,
            disabled: false,
          },
        ],
        model?.isServerSideData && !cliensideData && model?.processedData?.selectedCurrency
          ? model?.processedData?.selectedCurrency
          : ariesOffer?.['selectedCurrency']?.length
          ? ariesOffer?.['selectedCurrency']
          : [
              {
                label: model?.defaultLabel ?? 'Default',
                code: '',
                disabled: false,
              },
            ],
        {},
        [],
        [],
        true,
        taxFlag,
        model?.sortByData?.sortBy
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // get properties list on search form update
  // Search Data Receive from Offers Search Form
  useEffect(() => {
    if (!isFirstRender.current) {
      eventUtil.on('MPOSearchFormData', data => {
        setDataLoaderFlag(true);
        const searchFormData = data.searchFormData;
        setSearchData(searchFormData);
        setCurrentPage(1);
      });

      eventUtil.on('childAgeErrFlag', flag => {
        setErrorMessage(flag ? model?.childAgeEmptyError : '');
      });

      eventUtil.on('stayDateMissingErrFlag', flag => {
        setErrorMessage(flag ? model?.stayDateEmptyError : '');
      });

      eventUtil.remove('MPOSearchFormData', () => {
        ('');
      });
      eventUtil.remove('childAgeErrFlag', () => {
        ('');
      });
      eventUtil.remove('stayDateMissingErrFlag', () => {
        ('');
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPageCardCountInfo = (cardsTotalCount: number): string => {
    const total = Math.ceil(cardsTotalCount / cardsPerPage);
    const start = total === 1 || currentPage === 1 ? 1 : (currentPage - 1) * cardsPerPage + 1;
    const end = total === currentPage || currentPage === cardsTotalCount ? cardsTotalCount : currentPage * cardsPerPage;
    const countText = `${model?.showing} ${start}-${end} ${model?.of} ${cardsTotalCount} ${model?.hotel}`;
    return countText;
  };

  const [setDefaultSelectedFilters, updateSetDefaultSelectedFilters] = useState<boolean>(true);

  const processPropertiesList = async (propertiesListdata: any) => {
    if (updateCards) {
      setCliensideData(true); //allow client side data
      setDataLoaderFlag(true);
    }
    const modifiedPropertyCardData = modifyPropertyCardData(propertiesListdata);
    if (updateCards) {
      if (selectedCurrency?.[0]?.code) {
        const currencyConversionRateVal = await handleCurrencyChange(
          selectedCurrency,
          modifiedPropertyCardData?.hotels
        );
        setCurrencyConversionRate(currencyConversionRateVal);
      } else {
        //to set currencyConversionRate to 1 when default currency is selected
        const defaultCurrencyConversionRate: { [key: string]: number } = {};
        for (const key in currencyConversionRate) {
          defaultCurrencyConversionRate[key] = 1;
        }
        setCurrencyConversionRate(defaultCurrencyConversionRate);
      }
      setPropertyCardData({
        hotels: modifiedPropertyCardData?.hotels,
        totalProperties: modifiedPropertyCardData.totalProperties,
      });
    }

    // get available brands from UXL
    const facetObj = Enable_DTT_queries
      ? isStateOrCountryEnabled
        ? propertiesListdata?.search?.lowestAvailableRates?.searchByLocation?.facets ?? []
        : propertiesListdata?.search?.lowestAvailableRates?.searchByGeolocation?.facets ?? []
      : isStateOrCountryEnabled
      ? propertiesListdata?.searchLowestAvailableRatesByLocation?.facets ?? []
      : propertiesListdata?.searchLowestAvailableRatesByGeolocation?.facets ?? [];
    const propertiesFacetsBucket = facetObj;

    //brands
    const uxlAvailableBrandData = propertiesFacetsBucket?.filter((el: { type: { enumCode: string } }) => {
      return el?.type?.enumCode === 'BRANDS';
    });
    setAvailableBrands(uxlAvailableBrandData[0]?.buckets);
    //amenities
    const uxlAvailableAmenitiesData = propertiesFacetsBucket?.filter((el: { type: { enumCode: string } }) => {
      return el?.type?.enumCode === 'AMENITIES';
    });
    setAvailableAmenities(uxlAvailableAmenitiesData[0]?.buckets);
    const defaultSelectedAmenitities =
      destinationMetaData?.amenities?.length &&
      uxlAvailableAmenitiesData?.[0]?.buckets?.filter((item: any) => {
        return destinationMetaData?.amenities?.includes(item?.code);
      });
    keepDefaultFilters &&
      setDefaultSelectedFilters &&
      destinationMetaData?.amenities?.length &&
      setSelectedAmenities(defaultSelectedAmenitities);
    //transportation
    const uxlAvailableTransportationData = propertiesFacetsBucket?.filter((el: { type: { enumCode: string } }) => {
      return el?.type?.enumCode === 'TRANSPORTATION_TYPES';
    });
    setAvailableTransportaion(uxlAvailableTransportationData[0]?.buckets);
    //hotel type
    const uxlAvailableHotelTypeData = propertiesFacetsBucket?.filter((el: { type: { enumCode: string } }) => {
      return el?.type?.enumCode === 'PROPERTY_TYPES';
    });
    setAvailableHotelType(uxlAvailableHotelTypeData[0]?.buckets);
    const defaultSelectedHotelType =
      destinationMetaData?.hotelType?.length &&
      uxlAvailableHotelTypeData?.[0]?.buckets?.filter((item: any) => {
        return destinationMetaData?.hotelType?.includes(item?.code);
      });
    keepDefaultFilters &&
      setDefaultSelectedFilters &&
      destinationMetaData?.hotelType?.length &&
      setSelectedHotelType(defaultSelectedHotelType);
    //events
    const uxlAvailableEventsData = propertiesFacetsBucket?.filter((el: { type: { enumCode: string } }) => {
      return el?.type?.enumCode === 'MEETINGS_EVENTS';
    });
    setAvailableEvents(uxlAvailableEventsData[0]?.buckets);
    //activities
    const uxlAvailableActivitiesData = propertiesFacetsBucket?.filter((el: { type: { enumCode: string } }) => {
      return el?.type?.enumCode === 'ACTIVITIES';
    });
    setAvailableActivities(uxlAvailableActivitiesData[0]?.buckets);
    const defaultSelectedActivities =
      destinationMetaData?.activities?.length &&
      uxlAvailableActivitiesData?.[0]?.buckets?.filter((item: any) => {
        return destinationMetaData?.activities?.includes(item?.code);
      });
    keepDefaultFilters &&
      setDefaultSelectedFilters &&
      destinationMetaData?.activities?.length &&
      setSelectedActivities(defaultSelectedActivities);

    //add default selected filters to session
    keepDefaultFilters &&
      setDefaultSelectedFilters &&
      addFilterStateToSession(
        selectedBrands,
        destinationMetaData?.amenities?.length ? defaultSelectedAmenitities : selectedAmenities,
        selectedTransportaion,
        destinationMetaData?.hotelType?.length ? defaultSelectedHotelType : selectedHotelType,
        selectedEvents,
        destinationMetaData?.activities?.length ? defaultSelectedActivities : selectedActivities,
        selectedPrices,
        selectedCurrency,
        currencyConversionRate,
        selectedCity,
        selectedState,
        includeUnavailableProperties,
        showPricesTax,
        sortBy
      );
    //price
    const uxlAvailablePricesData = propertiesFacetsBucket?.filter((el: { type: { enumCode: string } }) => {
      return el?.type?.enumCode === 'PRICE';
    });
    setAvailablPrices(uxlAvailablePricesData[0]?.buckets);
    //city
    const uxlAvailableCityData = propertiesFacetsBucket?.filter((el: { type: { enumCode: string } }) => {
      return el?.type?.enumCode === 'CITIES';
    });
    setAvailableCity(uxlAvailableCityData[0]?.buckets);
    //state
    const uxlAvailableStateData = propertiesFacetsBucket?.filter((el: { type: { enumCode: string } }) => {
      return el?.type?.enumCode === 'STATES';
    });
    setIsNewFacetsLoading(false);
    setAvailableState(uxlAvailableStateData[0]?.buckets);
    if (updateCards) {
      setDataLoaderFlag(false);
      setPageCardCountInfo(getPageCardCountInfo(modifiedPropertyCardData?.totalProperties));
      modifiedPropertyCardData?.totalProperties === 0
        ? setErrorMessage(model?.offerParticipatingPropertiesError)
        : setErrorMessage('');
    }
    updateSetDefaultSelectedFilters(false);
    getSortByOptions(isStateOrCountryEnabled, modifiedPropertyCardData?.totalProperties);
  };
  const handlePropertiesError = () => {
    setIsNewFacetsLoading(false);
    if (updateCards) {
      setPageCardCountInfo(getPageCardCountInfo(0));
      setPropertyCardData({
        hotels: [],
        totalProperties: 0,
      });
      setDataLoaderFlag(false);
      //When API Fails show service unavailable error message. & Temporary adding mock data will remove when it is available from AEM
      setErrorMessage(
        alertCodeListModel?.alertMessageLabel ||
          model?.apiFailureMessageLabel ||
          "We're temporarily unable to display the information you requested. Please try again later."
      );
    }
  };

  //get properties list
  const [getPropertiesListdata, { data, loading }] = useLazyQuery(propertiesQuery, {
    fetchPolicy: 'network-only',
    errorPolicy: UXL_ERROR_POLICY,
    context: {
      headers: {
        'x-request-id': requestId + '-o-leisure-properties-list',
        'accept-language': acceptLanguage,
      },
    },
    onError: handlePropertiesError,
  });

  useEffect(() => {
    if (data && !loading) {
      setIsNewFacetsLoading(false);
    }
  }, [data, loading]);

  const getCurrencyList = (hotels: any): string[] => {
    const currList: string[] = [];
    hotels?.forEach((hotel: any) => {
      const currency = hotel?.footerLinkDetails?.currency;
      if (currency && !currList?.includes(currency)) {
        currList.push(currency);
      }
    });
    return currList;
  };
  const calculateCurrencyConversionRate = (currencyConversionData: any) => {
    if (
      currencyConversionData?.exchangeRateByCurrencyCodes?.outputCurrencyExchangeRate &&
      currencyConversionData.exchangeRateByCurrencyCodes?.outputCurrencyDecimalPoint
    ) {
      const conversionRate =
        currencyConversionData.exchangeRateByCurrencyCodes?.outputCurrencyExchangeRate /
        Math.pow(10, currencyConversionData.exchangeRateByCurrencyCodes.outputCurrencyDecimalPoint);
      // setCurrencyConversionRate(conversionRate);
      return conversionRate;
    } else return null;
  };
  const queryCommonContext = {
    /**
     * define common params for all the query
     */
    context: {
      headers: {
        'x-request-id': requestId,
        'accept-language': acceptLanguage,
      },
    },
  };
  const handleCurrencyChange = async (selectedCurrency: any, respObj?: any) => {
    const currencyList = getCurrencyList(
      model?.isServerSideData && !cliensideData && model?.processedData?.hotels?.length
        ? model?.processedData?.hotels
        : respObj
        ? respObj
        : propertyCardData?.hotels
    );
    type objType = { [key: string]: number };
    const obj: objType = {};
    await Promise.all(
      currencyList?.map(async (currency: string) => {
        const payLoad = {
          input: {
            inputCurrencyISOCode: currency,
            outputCurrencyISOCode: selectedCurrency?.[0]?.code,
            date: getESTDate(), //todays date
          },
        };
        const { data } = await getCurrencyExchangeRate({ variables: payLoad, ...queryCommonContext });
        const rate = calculateCurrencyConversionRate(data);

        const currencyKey = currency as keyof objType;
        if (rate) {
          obj[currencyKey] = rate;
        }
      })
    );
    setCurrencyConversionRate(obj);
    return obj;
  };
  const getCurrencyExchangeRate = (params: any) => {
    // get currency conversion rate for different currency
    /**** params = <query options to fetch conversion rate>
     */
    const queryOptions = { fetchPolicy: 'network-only', errorPolicy: 'all' };
    return apolloClientRef.query({
      ...queryOptions,
      query: phoenixLeisureExchangeRateByCurrencyCodes,
      ...params,
    });
  };

  //Code generate script for SEO
  const addJSONtoScript = (jsonLdData: any) => {
    if (document.getElementById('destinationproperty') === null) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'destinationproperty';
      script.insertAdjacentText('beforeend', JSON.stringify(jsonLdData));
      // Append the script to the head
      document.head.appendChild(script);
    }
  };
  //modify card data helper functions
  const modifyPropertyCardData = (resp: any) => {
    const respObj = Enable_DTT_queries
      ? isStateOrCountryEnabled
        ? resp?.search?.lowestAvailableRates?.searchByLocation ?? {}
        : resp?.search?.lowestAvailableRates?.searchByGeolocation ?? {}
      : isStateOrCountryEnabled
      ? resp?.searchLowestAvailableRatesByLocation ?? {}
      : resp?.searchLowestAvailableRatesByGeolocation ?? {};

    const edgeObj = respObj?.edges ?? [];
    const totalProperties = respObj?.total ?? 0;
    const propList = edgeObj;
    //Code to generate JSON schema for SEO
    const jsonLdData = constructJsonSchema(propList, cardsPerPage);
    addJSONtoScript(jsonLdData);
    const hotels = propList?.length
      ? propList.map((hotel: any) => {
          const {
            fullyRenovatedLabel,
            recentlyRenovatedLabel,
            newTagLabel,
            adultsOnlyLabel,
            renovatedLobbyLabel,
            renovatedRoomsLabel,
          } = model || {};
          const { basicInformation } = hotel?.node?.property || {};
          const isFullyRenovated = basicInformation?.isFullyRenovated;
          const isRecentlyRenovated = basicInformation?.isRecentlyRenovated;
          const hasRenovatedRooms = basicInformation?.hasRenovatedRooms;
          const newProperty = basicInformation?.newProperty;
          const isAdultsOnly = basicInformation?.isAdultsOnly;
          const newLobby = basicInformation?.newLobby;
          let ribbonDetails = null;

          if (isFullyRenovated) {
            ribbonDetails = {
              ribbonText: fullyRenovatedLabel,
              ribbonClass: 'fully-renovated-ribbon',
            };
          } else if (isRecentlyRenovated) {
            ribbonDetails = {
              ribbonText: recentlyRenovatedLabel,
              ribbonClass: 'recently-renovated-ribbon',
            };
          } else if (newProperty) {
            ribbonDetails = {
              ribbonText: newTagLabel,
              ribbonClass: 'new-hotel-ribbon ribbon',
            };
          } else if (isAdultsOnly) {
            ribbonDetails = {
              ribbonText: adultsOnlyLabel,
              ribbonClass: 'adult-hotel-ribbon',
            };
          } else if (newLobby) {
            ribbonDetails = {
              ribbonText: renovatedLobbyLabel,
              ribbonClass: 'renovated-lobby-ribbon',
            };
          } else if (hasRenovatedRooms) {
            ribbonDetails = {
              ribbonText: renovatedRoomsLabel,
              ribbonClass: 'renovated-rooms-ribbon',
            };
          }

          // Mandatory Fee
          const { isResort, isLACountyFee, isMarketingFee, isDestinationFee } =
            identifyTypeOfMandatoryFee(basicInformation);
          const mandatoryFeeTitle = constructMandatoryFeeTitle(
            isResort,
            isLACountyFee,
            isMarketingFee,
            isDestinationFee,
            model
          );
          const mandatoryFeeMessages = {
            title: constructToolTipTitle(isResort, isLACountyFee, isMarketingFee, isDestinationFee, model),
            feeDescription1: model?.includesLabel ?? INCLUDES_LABEL,
            feeDescription2: mandatoryFeeTitle ?? model?.feeDescription2,
            viewRatesLabel: model?.viewRatesLabel ?? VIEW_RATE_LABEL,
          };

          return {
            id: hotel?.node?.property?.id ?? '',
            sid: hotel?.node?.property?.basicInformation?.marshaBrandCode ?? '',
            brandCode: hotel?.node?.property?.basicInformation?.brand?.id ?? '',
            titleDetails: getTitleClientSide(
              hotel?.node?.property,
              hotel?.node?.property?.basicInformation?.brand?.id,
              subdirectory,
              model
            ),
            reviewsDetails: getReviewDetailsClientSide(
              hotel?.node?.property,
              hotel?.node?.property?.basicInformation?.brand?.id,
              hotel?.node?.distance,
              subdirectory,
              model,
              currentLocaleVal,
              getCalculatedDistance
            ),
            description: getDescriptionText(hotel?.node?.property?.basicInformation?.descriptions),
            images: getPropertyImages(hotel?.node?.property),
            tertiaryLinkDetails: generateDetailsPageURL(
              hotel?.node?.property?.seoNickname ?? '',
              hotel?.node?.property?.basicInformation?.brand?.id
            ),
            footerLinkDetails: getFooterDetails(
              hotel,
              clusterCode,
              model,
              subdirectory,
              showPricesTax,
              Enable_DTT_queries
            ),
            mandatoryFeeObj: {
              amountPlusMandatoryFee: getAmountPlusMandatoryFeeDetails(hotel),
              mandatoryFee: getMandatoryFeeDetails(hotel),
              mandatoryFeeDescription: getMandatoryFeeDescription(
                hotel?.node?.property?.basicInformation?.descriptions
              ),
              ...mandatoryFeeMessages,
            },
            brandDetails: {
              brandId: hotel?.node?.property?.basicInformation?.brand?.id,
              label: '',
              hasUniquePropertyLogo: hotel?.node?.property?.basicInformation?.hasUniquePropertyLogo,
            },
            ribbonDetails: ribbonDetails,
            // ...add any other fields as needed...
          };
        })
      : [];
    return {
      hotels: hotels,
      totalProperties: totalProperties,
    };
  };

  const getDescriptionText = (descriptions: any) => {
    return descriptions?.find((desc: any) => desc?.type?.enumCode === HOTEL_MARKETING_CAPTION)?.text || '';
  };

  const getPropertyImages = (data: any) => {
    const photoGalleryObj = data.media.photoGallery;
    const propertyImageList: any = [];
    const propertyImageArray: any = [];
    let cauroselImages: any = [];
    const edgesList: any = [];

    if (photoGalleryObj) {
      Object.keys(photoGalleryObj).forEach((categoryKey: any) => {
        const propertyObject: any = [];
        if (categoryKey !== '__typename' && photoGalleryObj[categoryKey]) {
          propertyObject['categoryCode'] = categoryKey;
          propertyObject['photosObj'] = photoGalleryObj[categoryKey];
          propertyImageList.push(propertyObject);
        }
      });
    }
    if (data?.media?.primaryImage?.edges?.[0]?.node?.imageUrls) {
      const hotelViewObj: any = [];
      hotelViewObj['categoryCode'] = HOTEL_VIEW;
      hotelViewObj['photosObj'] = data?.media?.primaryImage;
      propertyImageList.unshift(hotelViewObj);
    }
    propertyImageList.forEach((edgeCollection: any) => {
      edgesList.push(edgeCollection?.photosObj?.edges);
      edgesList?.forEach((photosList: any) => {
        photosList?.forEach((imgNode: any) => {
          const wideImg = imgNode?.node?.imageUrls?.wideHorizontal;
          const altText = imgNode?.node?.alternateDescription || '';
          if (wideImg !== null && wideImg !== '') {
            propertyImageArray.push({
              defaultImageUrl: MARRIOTT_CACHE_URL + wideImg + imageProperties,
              altText: altText,
            });
            cauroselImages = Array.from(
              new Map(propertyImageArray.map((item: any) => [item.defaultImageUrl, item])).values()
            ).slice(0, 10);
          }
        });
      });
    });
    if (cauroselImages?.length < 1) {
      const brandFallbackImageArray: any = {};
      brandFallbackImageArray['defaultImageUrl'] = data?.basicInformation?.brand?.photos?.[0]?.content?.[0]?.url;
      brandFallbackImageArray['altText'] = data?.basicInformation?.name ?? '';
      cauroselImages.push(brandFallbackImageArray);
    }
    return cauroselImages;
  };
  const generateDetailsPageURL = (seoNickname: string, brandId: string) => {
    const detailsPage =
      brandId === 'RZ'
        ? `https://www.ritzcarlton.com/en/hotels/${seoNickname}/overview/`
        : (subdirectory ? `/${subdirectory}` : '/en-us') + `/hotels/${seoNickname}/overview/`;
    const footerlinks = {
      href: detailsPage,
      target: '_blank',
      custom_click_track_value: `${model?.id}|${model?.storefrontPropertyHotelDetails}|${EXTERNAL_CTA_TYPE}`,
      rel: 'noreferrer',
      className: 'm-link-tertiary-button outlet-resevation-link custom_click_track ',
      buttonCopy: `${model?.storefrontPropertyHotelDetails}`,
      isLink: true,
      onClick: () => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        (): Window | null => window.open(`${detailsPage}`, '_self');
      },
    };
    return footerlinks;
  };

  const getRatesNode = (hotel: any) => {
    return hotel?.node?.rates?.[0];
  };

  const getPriceOnToggleSelection = (hotel: any) => {
    let amount;
    if (Enable_DTT_queries) {
      const lowestAverageRate = hotel?.node?.rates?.[0]?.rateModes?.lowestAverageRate;
      amount = lowestAverageRate?.totalAmount;
    } else {
      amount =
        hotel?.node?.rates?.[0]?.rateAmounts?.[0]?.totalAmount?.origin ??
        hotel?.node?.rates?.[0]?.rateAmounts?.[0]?.amount?.origin;
    }

    return amount;
  };

  const getAmountPlusMandatoryFeeDetails = (hotel: any) => {
    const rateObj = getRatesNode(hotel);
    const rateStatus = rateObj?.status?.code ?? 'unavailable';
    let mandatoryFee;
    if (rateStatus === 'available' || rateStatus === 'AvailableForSale') {
      if (showPricesTax) {
        mandatoryFee = getPriceOnToggleSelection(hotel);
      } else {
        let feeObj;
        if (acceptLanguage.toLocaleLowerCase() === 'ja-jp' || countryCode === 'JP' || !mandatoryFeesEnabled) {
          feeObj = Enable_DTT_queries
            ? rateObj?.rateModes?.lowestAverageRate?.amount
            : rateObj?.rateAmounts?.[0]?.amount?.origin;
        } else {
          feeObj = Enable_DTT_queries
            ? rateObj?.rateModes?.lowestAverageRate?.amountPlusMandatoryFees ?? 0
            : rateObj?.rateAmounts?.[0]?.amountPlusMandatoryFees?.origin ?? 0;
        }
        mandatoryFee = feeObj ?? {};
      }
    }
    const amount = Enable_DTT_queries ? mandatoryFee?.amount : mandatoryFee?.value;
    const decimalPoint = Enable_DTT_queries ? mandatoryFee?.decimalPoint : mandatoryFee?.valueDecimalPoint;
    const totalPrice = mandatoryFee && amount ? Math.round(amount / Math.pow(10, decimalPoint as number)) : 0;
    return totalPrice;
  };
  const getMandatoryFeeDetails = (hotel: any) => {
    // Locale is not Allowed, then we should not display the mandatory fee.
    // We pass flag "mandatoryFeesEnabled" in payload. if its false then mandatory fee should not display.
    if (!mandatoryFeesEnabled) {
      return;
    }
    const rateObj = getRatesNode(hotel);
    const mandatoryFee = Enable_DTT_queries
      ? rateObj?.rateModes?.lowestAverageRate?.mandatoryFees
      : rateObj?.rateAmounts?.[0]?.mandatoryFees?.origin;
    const mandatoryFeeDTT = {
      currency: mandatoryFee?.currency,
      value: Math.round(mandatoryFee?.value ?? mandatoryFee?.amount ?? 0),
      valueDecimalPoint: mandatoryFee?.decimalPoint ?? mandatoryFee?.valueDecimalPoint,
    };
    return mandatoryFeeDTT;
  };

  // Optimized sort options function
  const getSortByOptions = (isStateOrCountryEnabled: boolean, totalprop: number) => {
    if (isFirstRender.current) return;

    const baseOptions = [
      { sortByOptionTitle: model?.priceLowToHighLabel, sortByOptionCode: 'PRICE' },
      { sortByOptionTitle: model?.cityLabel, sortByOptionCode: 'CITY' },
      { sortByOptionTitle: model?.storefrontPropertyBrandFilter, sortByOptionCode: 'BRAND' },
      { sortByOptionTitle: model?.guestRatingLabel, sortByOptionCode: 'GUEST_RATINGS' },
      { sortByOptionTitle: model?.noOfReviewsLabel, sortByOptionCode: 'NUM_REVIEWS' },
    ];

    if (isStateOrCountryEnabled) {
      const options =
        typeof totalprop === 'number' && totalprop > 200
          ? baseOptions.filter(option => option.sortByOptionCode !== 'PRICE')
          : baseOptions;
      setSortOptions(options);
      return;
    }

    setSortOptions([{ sortByOptionTitle: model?.distanceLabel, sortByOptionCode: 'DISTANCE' }, ...baseOptions]);
  };

  const handleSortBy = (event: any, sortOption: string): void => {
    setDataLoaderFlag(true);
    setCliensideData(true);
    setUpdateCards(true);
    const ariesOffer = globalData?.sessionData?.cacheData?.data?.AriesOffer;
    handleSortByEvent({
      event,
      sortOption,
      ariesOffer,
      handleApplyFilter,
    });
  };

  return (
    <StyledPropertiesListWrapper className={`${model?.styleclass}`}>
      <div className={`container offer-properties-list`}>
        <div>
          <PropertiesListFilter
            model={model}
            destinationMetaData={destinationMetaData}
            availableBrands={availableBrands}
            availabledAmenities={availabledAmenities}
            availableTransportaion={availableTransportaion}
            availableHotelType={availableHotelType}
            availablEvents={availablEvents}
            availablActivities={availablActivities}
            availablPrices={availablPrices}
            availableCity={availableCity}
            availablState={availablState}
            handleApplyFilter={handleApplyFilter}
            handleApplyCurrencyFilter={handleApplyCurrencyFilter}
            selectedBrands={selectedBrands}
            selectedAmenities={selectedAmenities}
            selectedTransportaion={selectedTransportaion}
            selectedHotelType={selectedHotelType}
            selectedEvents={selectedEvents}
            selectedActivities={selectedActivities}
            selectedPrices={selectedPrices}
            defaultCurrency={defaultCurrency}
            selectedCurrency={selectedCurrency}
            handleDynamicCurrency={handleDynamicCurrency}
            currencyConversionRate={currencyConversionRate}
            selectedCity={selectedCity}
            selectedState={selectedState}
            brandFacets={brandFacets}
            amentiesFacets={amentiesFacets}
            transportaionFacets={transportaionFacets}
            hotelTypeFacets={hotelTypeFacets}
            eventsFacets={eventsFacets}
            activitiesFacets={activitiesFacets}
            cityFacets={cityFacets}
            stateFacets={stateFacets}
            priceDimension={priceDimension}
            includeUnavailableProperties={includeUnavailableProperties}
            isTaxSliderActive={dynamicShowPricesTax}
            defaultTaxFlag={taxFlag}
            handleClearAllFilters={handleClearAllFilters}
            handleDynamicBrands={handleDynamicBrands}
            handleDynamicAmenities={handleDynamicAmenities}
            handleDynamicTransportaion={handleDynamicTransportaion}
            handleDynamicHotelTypes={handleDynamicHotelTypes}
            handleDynamicActivities={handleDynamicActivities}
            handleDynamicEvents={handleDynamicEvents}
            handleDynamicPrices={handleDynamicPrices}
            handleDynamicPricesAndTax={handleDynamicPricesAndTax}
            handleDynamicCities={handleDynamicCities}
            handleDynamicStates={handleDynamicStates}
            handleDynamicIncludeUnavailableProperties={handleDynamicIncludeUnavailableProperties}
            isNewFacetsLoading={isNewFacetsLoading}
            requestId={requestId}
            acceptLanguage={acceptLanguage}
            sessionData={sessionDataUpdate}
            featureFlagLogo={props?.featureFlagLogo}
            isStateEnabled={isStateEnabled}
            cliensideData={cliensideData}
          />
        </div>

        {model?.isServerSideData && !cliensideData ? (
          !model?.processedData?.hotels?.length ? (
            <AlertNotification
              errorMessage={
                model?.serverApiError
                  ? alertCodeListModel?.alertMessageLabel ||
                    model?.apiFailureMessageLabel ||
                    "We're temporarily unable to display the information you requested. Please try again later."
                  : model?.offerParticipatingPropertiesError
              }
              className={'no-hotels-found alert'}
              setLinkClick={() => {
                // reload same page
                window.location.reload();
              }}
              linkText={alertCodeListModel?.alertLinkTextLabel}
              alertType={alertMsgType}
              linkClassName={'m-link'}
            />
          ) : (
            <>
              <div className="sort-by-wrapper mb-1">
                <div className="page-card-count">
                  <p className={clsx(isMobileViewPort ? 't-font-s' : 't-subtitle-l', 'pb-1', 'mb-0')}>
                    {model?.processedData?.cardCountText}
                  </p>
                </div>
                <SortByFilterComponent
                  handleSortBy={handleSortBy}
                  sortOptions={model?.sortByData?.sortOptions}
                  currSortByOption={model?.sortByData?.sortBy}
                  sortByLabel={model?.sortByLabel}
                  destinationMetaData={model?.sortByData?.destinationMetaData}
                  isServerSideData={true}
                />
              </div>
              <div className={clsx(isGridview ? 'grid-view' : '')}>
                {model?.processedData?.hotels?.length > 0 &&
                  model?.processedData?.hotels.map((hotel: any) => (
                    <PropertyCard
                      key={hotel.id} // Ensure each hotel has a unique key, assuming `id` exists
                      {...hotel}
                      isMBOP={true}
                      rateDetails={{
                        currencyConversionRate:
                          model?.processedData?.currencyConversionRate?.[hotel?.footerLinkDetails?.currency],
                        priceType: `${
                          model?.processedData?.selectedCurrency?.[0]?.code
                            ? model?.processedData?.selectedCurrency?.[0]?.code
                            : hotel?.footerLinkDetails?.currency ?? hotel?.footerLinkDetails?.currency
                        } / ${model?.storefrontPropertyNight}`,
                      }}
                      serverSideViewport={model?.viewPort}
                      isServerSideData={true}
                      trackingProperties={trackingProperties}
                      addScrimToImage={true}
                      enablePropertyCarouselControl={true} //this flag used to match SERP property carousel control implementation of bullet points
                      isTaxesAndFeesEnabled={model?.processedData?.showPricesTax} // This flag used to show the Taxes & Mandatory Fees
                      taxesAndFeesIncludedText={model.storefrontPropertyTaxesAndFeesIncluded}
                      featureFlagLogo={props?.featureFlagLogo}
                      acceptLanguage={acceptLanguage}
                      showMobileVariantOnly={isGridview}
                    />
                  ))}
              </div>
              <div className="pagination-container mt-5">
                <Pagination
                  currentPage={model?.paginationData?.currentPage}
                  totalCount={model?.processedData?.totalProperties ?? 770}
                  pageSize={model?.paginationData?.cardsPerPage}
                  onPageChange={() => {}}
                  labels={paginationPanelLabel}
                  seoFriendlyPagination={model?.seoFriendlyPagination}
                  queryParamName={PARAM_PAGENO}
                  baseURL={model?.baseURL}
                />
              </div>
            </>
          )
        ) : (
          <>
            {dataLoaderFlag && cliensideData ? (
              <div className="pt-5 pb-5">
                {isGridview ? (
                  <PropertiesListGridViewSkeletonLoader numberOfCards={12} />
                ) : (
                  <SkeletonOutletCardLoader />
                )}
              </div>
            ) : errorMessage && cliensideData ? (
              <AlertNotification
                errorMessage={errorMessage}
                className={'no-hotels-found alert'}
                setLinkClick={() => {
                  window.location.reload();
                }}
                linkText={alertCodeListModel?.alertLinkTextLabel}
                alertType={alertMsgType}
                linkClassName={'m-link'}
              />
            ) : (
              <>
                <div className="sort-by-wrapper mb-1">
                  <div className="page-card-count">
                    <p className={clsx(isMobileViewPort ? 't-font-s' : 't-subtitle-l', 'pb-1', 'mb-0')}>
                      {pageCardCountInfo}
                    </p>
                  </div>
                  <SortByFilterComponent
                    handleSortBy={handleSortBy}
                    sortOptions={sortOptions}
                    currSortByOption={sortBy}
                    sortByLabel={model?.sortByLabel}
                    destinationMetaData={destinationMetaData}
                    isServerSideData={false}
                  />
                </div>
                <div className={clsx(isGridview ? 'grid-view' : '')}>
                  {cliensideData &&
                    propertyCardData?.hotels?.length &&
                    propertyCardData?.hotels?.map((hotel: any) => (
                      <PropertyCard
                        key={hotel.id} // Ensure each hotel has a unique key, assuming `id` exists
                        {...hotel}
                        isMBOP={true}
                        rateDetails={{
                          currencyConversionRate: currencyConversionRate?.[hotel?.footerLinkDetails?.currency],
                          priceType: `${
                            selectedCurrency?.[0]?.code
                              ? selectedCurrency?.[0]?.code
                              : hotel?.footerLinkDetails?.currency
                          } / ${model?.storefrontPropertyNight}`,
                        }}
                        isServerSideData={false}
                        trackingProperties={trackingProperties}
                        addScrimToImage={true}
                        enablePropertyCarouselControl={true} //this flag used to match SERP property carousel control implementation of bullet points
                        isTaxesAndFeesEnabled={showPricesTax} // This flag used to show the Taxes & Mandatory Fees
                        taxesAndFeesIncludedText={model.storefrontPropertyTaxesAndFeesIncluded}
                        featureFlagLogo={props?.featureFlagLogo}
                        acceptLanguage={acceptLanguage}
                        showMobileVariantOnly={isGridview} // Show mobile variant only in grid view
                      />
                    ))}
                </div>
                {cliensideData && (
                  <div className="pagination-container mt-5">
                    <Pagination
                      currentPage={currentPage}
                      totalCount={propertyCardData.totalProperties ?? 0}
                      pageSize={cardsPerPage}
                      onPageChange={(page: number): void => onPageItemClick(page)}
                      labels={paginationPanelLabel}
                      seoFriendlyPagination={model.seoFriendlyPagination}
                      queryParamName={PARAM_PAGENO}
                    />
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </StyledPropertiesListWrapper>
  );
};
export default PropertiesListWrapper;
